<template>
    <transition name="fade" appear>
        <div class="ar-popin-container">
            {{ text }}
        </div>
    </transition>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "ARPopin",
    props: {
        text: {
            type: String,
            required: true
        }
    }
});
</script>
<style scoped>
.ar-popin-container {
    background-color: var(--secondary);
    border: 2px solid var(--white);
    color: var(--buttonTextColor);
    border-radius: 15px;
    text-align: center;
    padding: 10px;
}
</style>
